import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { DatabaseBackup, Download } from "lucide-react";
import { api, messageErreur } from "@/lib/api";
import { formatDateHeure, formatTaille, formatNombre } from "@/lib/format";
import { Vide } from "@/components/commun";

export default function Sauvegardes() {
  const [liste, setListe] = useState([]);
  const [envoi, setEnvoi] = useState(false);
  const charger = useCallback(() => api.get("/sauvegardes").then((r) => setListe(r.data)), []);
  useEffect(() => { charger(); }, [charger]);

  const lancer = async () => {
    setEnvoi(true);
    try { await api.post("/sauvegardes"); toast.success("Sauvegarde effectuée."); charger(); }
    catch (e) { toast.error(messageErreur(e)); } finally { setEnvoi(false); }
  };
  const telecharger = async (s) => {
    const { data } = await api.get(`/sauvegardes/${s.id}/telecharger`, { responseType: "blob" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(data);
    a.download = `airthermo-sauvegarde-${s.date.slice(0, 10)}.json.gz`;
    a.click();
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
        <div>
          <h2 className="text-base md:text-lg font-bold">Sauvegardes</h2>
          <p className="at-muted text-sm mt-1">Sauvegarde automatique chaque nuit à 2 h ; les 14 dernières sont conservées.</p>
        </div>
        <button type="button" onClick={lancer} disabled={envoi} className="at-btn at-btn-primary" data-testid="backup-run-button"><DatabaseBackup size={17} />{envoi ? "Sauvegarde…" : "Sauvegarder maintenant"}</button>
      </div>
      {liste.length === 0 && <Vide texte="Aucune sauvegarde pour l'instant." testId="backups-empty" />}
      <div className="space-y-2" data-testid="backups-list">
        {liste.map((s) => (
          <div key={s.id} className="at-fiche p-4 flex items-center justify-between gap-3" data-testid={`backup-item-${s.id}`}>
            <div className="min-w-0">
              <p className="font-bold">{formatDateHeure(s.date)}</p>
              <p className="text-sm at-muted">{s.origine === "manuelle" ? "Manuelle" : "Automatique"} · {formatTaille(s.taille_octets)} · {formatNombre(Object.values(s.collections).reduce((a, b) => a + b, 0))} éléments</p>
            </div>
            <button type="button" className="at-icon-btn at-btn-ghost shrink-0" aria-label="Télécharger" onClick={() => telecharger(s)} data-testid={`backup-download-${s.id}`}><Download size={17} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
